"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.INTERNAL_APP_IDS = exports.DEFAULT_MULTIBUY_APP_ID = exports.DISCOVER_INITIAL_CATEGORY = exports.DISCOVER_STORE_KEY = exports.DAPP_DISCLAIMER_ID = exports.MAX_RECENTLY_USED_LENGTH = exports.INITIAL_PLATFORM_STATE = exports.HTTP_REGEX = exports.BROWSE_SEARCH_OPTIONS = exports.WALLET_API_VERSION = exports.WALLET_API_FAMILIES = void 0;
var wallet_api_core_1 = require("@ledgerhq/wallet-api-core");
Object.defineProperty(exports, "WALLET_API_FAMILIES", { enumerable: true, get: function () { return wallet_api_core_1.FAMILIES; } });
exports.WALLET_API_VERSION = "2.0.0";
exports.BROWSE_SEARCH_OPTIONS = {
    keys: ["name", "categories"],
    threshold: 0.1,
};
exports.HTTP_REGEX = new RegExp(/[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)?/gi);
exports.INITIAL_PLATFORM_STATE = { recentlyUsed: [] };
exports.MAX_RECENTLY_USED_LENGTH = 10;
exports.DAPP_DISCLAIMER_ID = "PlatformAppDisclaimer";
exports.DISCOVER_STORE_KEY = "discover";
exports.DISCOVER_INITIAL_CATEGORY = "all";
exports.DEFAULT_MULTIBUY_APP_ID = "multibuy";
exports.INTERNAL_APP_IDS = ["multibuy"];
//# sourceMappingURL=constants.js.map